module.exports = __webpack_public_path__ + "img/fs_yiji.0ea88f78.png";